/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NavigationRpc
 */
import * as References from './NavigationRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NavigationRpc#getNavigationManifests
 */
export const GET_NAVIGATION_MANIFESTS_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_NavigationRpc_getNavigationManifests';
export const GET_NAVIGATION_MANIFESTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_NAVIGATION_MANIFESTS_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getNavigationManifestsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NavigationRpc#getPortalNavigation
 */
export const GET_PORTAL_NAVIGATION_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_NavigationRpc_getPortalNavigation';
export const GET_PORTAL_NAVIGATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_NAVIGATION_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPortalNavigationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});